export const selectAnswerAction = function (answer, question, form) {
    return {
        type: "SELECT_ANSWER",
        payload: answer,
        question: question,
        form: form
    }
};

export const selectOtherAnswerAction = function (answer, question, form) {
    return {
        type: "SELECT_OTHER_ANSWER",
        payload: answer,
        question: question,
        form: form
    }
};

export const addAnswersAction = function (answers, form) {
    return {
        type: "ADD_ANSWERS",
        payload: answers,
        form: form
    }
};

export const noteChangeAction = function (note, question, form, test) {
    return {
        type: "CHANGE_NOTE",
        payload: note,
        question: question,
        form: form,
        test: test
    }
}

export const addNotesAction = function (form, test) {
    return {
        type: "ADD_NOTES",
        payload: form,
        test: test,
    }
}


// WEBPACK FOOTER //
// ./src/redux/creators/answers.js